import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2ReservationprogramElFindParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2ReservationprogramElFindParams, unknown>

const fetchReservationProgramList = async (params: ApiV2ReservationprogramElFindParams) => {
  const { data } = await apiClient.v2.apiV2ReservationprogramElFind(params);
  return checkApiResponse(data);
}

export const v2ReservationProgramKeys = {
  all: [QUERY_KEY.v2apiV2ReservationprogramElFind] as const,
  list: (params: ApiV2ReservationprogramElFindParams) => [...v2ReservationProgramKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2ReservationProgramFindQueryOptions(params))` */
export const v2ReservationProgramFindQueryOptions = (params: ApiV2ReservationprogramElFindParams) => ({
  queryKey: v2ReservationProgramKeys.list(params),
  queryFn: () => fetchReservationProgramList(params),
})

export const useV2ReservationProgramFindQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2ReservationProgramKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchReservationProgramList(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}

/**
 * 프로그램 목록 표준 조회 — FCM 은 sort 변경만 커버라 staleTime 5분.
 * 특수 조건 조회(기간 필터·keyword 등)는 기존 v2ReservationProgramFindQueryOptions 를 그대로 사용한다 (staleTime 0 유지).
 */
export const v2ReservationProgramListQueryOptions = (hospitalID: string) => ({
  // swagger 생성 타입이 hospitalID 를 boolean 으로 잘못 문서화하고 있어 캐스팅 (서버 스웨거 주석 오류)
  ...v2ReservationProgramFindQueryOptions({ hospitalID, isRemoved: false, key: 'sortNum', way: 1 } as unknown as ApiV2ReservationprogramElFindParams),
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})
